import { Paragraph, convertMillimetersToTwip } from 'docx'
import { DraftTextHighlighterItem } from '../../data/gql-gen/questionnaire/graphql'
import {
  DraftQuestionnaireEntry,
  QuestionSettingCode
} from '../../data/model/questionnaire'
import { getQuestionEnabledSettings } from '../questionnaireUtils'
import { Order } from './model'

export const createEntryContentTextHighlighter = async (
  entry: DraftQuestionnaireEntry
): Promise<Paragraph[]> => {
  const entryItem = entry.entryItem as DraftTextHighlighterItem

  const paragraphs = [new Paragraph(entryItem.content.text)]

  for (const [index, category] of entryItem.highlighterCategories.entries()) {
    paragraphs.push(
      new Paragraph({
        text: `${index + 1}. [${category.colour.label}] ${
          category.responseOption.value
        }`,
        indent: {
          start: convertMillimetersToTwip(6.3)
        }
      })
    )
  }

  const enabledSettings = getQuestionEnabledSettings(entryItem.settingValues)

  if (enabledSettings.has(QuestionSettingCode.RandomiseOptions)) {
    paragraphs.push(new Paragraph(Order.Randomise))
  }

  if (enabledSettings.has(QuestionSettingCode.TextHighlighterComments)) {
    paragraphs.push(new Paragraph('Enable comments on highlights'))
  }

  return paragraphs
}
